module.exports = __webpack_public_path__ + "static/media/Adnan.b001b7c1.jpg";